import Auth from './auth';
import Global from './global';
import Util from './util';
import Constants from './constants';

let CHANNEL_CODE = Util.getChannelCode();
console.log('event-bus channel code>>>', CHANNEL_CODE);
let chromeVersion = 0;
const callbackMap = new Map();
let channel = null;//for onMessage
let channel2 = null;//for postMessage
export function postMessage(eventCode, message, crossDomains, noAuth = false, config = {}) {
  console.log(`postMessage eventCode>>>${eventCode}`, CHANNEL_CODE, crossDomains);
  if(!window.BroadcastChannel){
    console.error('not support window.BroadcastChannel')
    return;
  }
  if(crossDomains){
    let body = document.body;
    if(Array.isArray(crossDomains) && crossDomains.length <= 0){
      crossDomains = Global.getCustomConfig()['KIAF_CROSS_EVENT_BUS_DOMAINS'] || Global.getCustomConfig()['CROSS_EVENT_BUS_DOMAINS'] || [];
    }
    console.log('postMessage crossDomains2>>>', crossDomains);
    crossDomains.forEach((url) => {
      if(url.indexOf('https://') != 0 && url.indexOf('http://') != 0) { //url is channel code
        let bc = new window.BroadcastChannel(url);
        let data = {
          timestamp: new Date().getTime(),
          eventCode: eventCode,
          message: message
        };
        bc.postMessage(data);
        bc.close();
      }else{
        let iframe = document.createElement('iframe');
        let eventbus = {
          eventCode: eventCode,
          message: message
        };
        // let query = 'cross_event_bus=' + encodeURIComponent(JSON.stringify(eventbus)) + '&v=' + new Date().getTime();
        let query = 'v=' + new Date().getTime();
        if(config && config.postMessage){
          // 传递大数据时，url参数大小有局限,采用postMessage的方法
        } else {
          query = 'cross_event_bus=' + encodeURIComponent(JSON.stringify(eventbus)) + '&v=' + new Date().getTime();
        }
        if(url.indexOf('?') > 0){
          url = url + '&' + query;
        } else {
          url = url + '?' + query;
        }
        console.log('event-bus postMessage>>>config', config);
        console.log('event-bus postMessage>>>url', url);
        iframe.setAttribute('src', url);
        iframe.setAttribute('width', 0);
        iframe.setAttribute('height', 0);
        iframe.setAttribute('style', 'display:none');
        body.appendChild(iframe);
        iframe.onload = () => {
          console.log('iframe onload');
          if(config && config.postMessage){
            //传递大数据时，url参数大小有局限,采用postMessage的方法
            setTimeout(() => {
              iframe.contentWindow.postMessage({
                  code: 'cross_event_bus',
                  body: eventbus
                },
                '*');
            }, 1000);
          }
          setTimeout(() => {
            body.removeChild(iframe);
          }, 3000);
        };
      }
    });
  } else {
      if(!channel2){
        channel2 = new window.BroadcastChannel(CHANNEL_CODE);
      }
      if(Global.isInternalWebview() && (eventCode === Constants.EVENT_BUS_CODE_ADDTAG || eventCode === Constants.EVENT_BUS_CODE_SWITCH_WINDOW)){
        let crossDomains = [];
        if(Global.getParentAppHost()){
          crossDomains.push(Global.getParentAppHost());
        }
        if(eventCode === Constants.EVENT_BUS_CODE_SWITCH_WINDOW){
          postMessage(Constants.EVENT_BUS_CODE_SWITCH_WINDOW, message, crossDomains);
        } else {
          if(Global.isParentNoTag()){
            message.path = message.url;
            postMessage(Constants.EVENT_BUS_CODE_NEXT_ROUTE, message);
          } else {
            message.url = Util.getFullUrl(message.url);
            postMessage(Constants.EVENT_BUS_CODE_PARENT_ADDTAG, message, crossDomains);
          }
        }
      } else {
        let data = Util.clone({ // clone first,避免message中包含了Proxy
          timestamp: new Date().getTime(),
          eventCode: eventCode,
          message: message
        });
        if(Global.getCustomConfig()['KIAF_SPA'] == 'N'){ //仅仅向当前窗口发送消息
          data.windowId = window.name;
        }
        if(noAuth){
          channel2.postMessage(data);
        }else if (!Util.isEmpty(Auth.getJwtToken())) {
          channel2.postMessage(data);
        }
      }
  }
};


export function onMessage(eventCode, callback, vueInstance) {
  if(!window.BroadcastChannel){
    console.error('not support window.BroadcastChannel')
    return;
  }
  if(this && !vueInstance){
    vueInstance = this;
  }
    let fn = (data) => {
      // 判断是否是vue实例，是的话判断是否已经销毁。销毁则移除
      if (vueInstance && ((vueInstance._isVue && vueInstance._isDestroyed) || (vueInstance.$ && vueInstance.$.isUnmounted))) {
        if (callbackMap.has(fn)) {
          callbackMap.delete(fn);
        }
        return;
      }
      if(callback && data != 'KIAF_CLOSE_EXPIRED_MESSAGE'){
        callback(data);
      }
    };
    callbackMap.set(fn, {
      callback: fn,
      vueInstance,
      eventCode
    });
    if(!channel){
      channel = new window.BroadcastChannel(CHANNEL_CODE);//for onMessage
      channel.addEventListener('message', (res) => {
        let currEventCode = '';
        let currMessageBody = {};
        if(res.data){
          currEventCode = res.data.eventCode;
          currMessageBody = res.data.message;
        }
        for (let data of callbackMap.values()) {
          if (data.eventCode === currEventCode && (!res.data.windowId || (res.data.windowId && window.name == res.data.windowId) || data.eventCode == Constants.EVENT_BUS_CODE_CLOSE_ALL_WIN)) {
            // console.log('onMessage>>>', data.eventCode + ',' + currEventCode);
            if (data.eventCode === Constants.EVENT_BUS_CODE_CLOSE_ALL_WIN) {
              Util.isWindowClosed(function (result) {
                console.log(`isWindowClosed>>>${result}`);
                if (result) {
                  // window.opener = this;
                  window.close();
                  Auth.clearJwtToken();
                  location.href = Util.getFullUrl(Constants.HOME_PAGE_LOGIN);
                }
              }, currMessageBody);
            }
            if(data.callback){
              try {
                data.callback(res.data.message);
              }catch (e) {
                console.log('event bus error>>>', e);
              }
            }
          }
        }
      });
    }
};

export function getChromeVersion() {
  if (chromeVersion <= 0) {
    let arr = navigator.userAgent.split(' ');
    var result = '';
    for (let i = 0; i < arr.length; i++) {
      if (/chrome/i.test(arr[i])) {
        result = arr[i];
      }
    }
    if (result) {
      chromeVersion = Number(result.split('/')[1].split('.')[0]);
    }
  }
  return chromeVersion;
}

for(let key in localStorage){
  if(key.indexOf(CHANNEL_CODE + '_NAMESPACE_') === 0){
    localStorage.removeItem(key);
  }
}

export function closeExpiredMessage() {
  // console.log('closeExpiredMessage>>>', callbackMap);
  for (let data of callbackMap.values()) {
    if(data.callback){
      try {
        data.callback('KIAF_CLOSE_EXPIRED_MESSAGE');
      }catch (e) {
        console.log('event bus error>>>', e);
      }
    }
  }
  // console.log('closeExpiredMessage end>>>', callbackMap);
}

export function removeOnMessage(eventCode, vueInstance) {
  if(!vueInstance && this){
    vueInstance = this;
  }
  for (let data of callbackMap.values()) {
    if(data.eventCode == eventCode && data.vueInstance == vueInstance){
      callbackMap.delete(data.callback);
    }
  }
}
